export function getPlanDeshabilitados() {
  try {
    return JSON.parse(localStorage.getItem('empresa_plan') || '{}').items_deshabilitados || [];
  } catch { /* plan check — ignore */ }
  return [];
}

export function isRouteEnabled(to) {
  return !getPlanDeshabilitados().includes(to);
}
